import React, { useState, useEffect } from "react";
import { ScrollView, Text, TouchableOpacity, Image, Dimensions } from "react-native";
//import { AntDesign } from "@expo/vector-icons";
//import PagerView from "react-native-pager-view";
//import MaterialTabs from "react-native-material-tabs";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../components/Tabs/react-tabs.css';
import { useNavigation } from "@react-navigation/native";
import AsyncStorage from '@react-native-async-storage/async-storage';

import CardsHome from "../../components/CardsHome";
import Header from "../../components/Header";
import ScreenLoader from "../../components/ScreenLoader";
import TokenReleases from "../../components/TokenReleases";
import { toast } from "../../utils/toast";
import api from "../../services/api";
import styles from "./styles";

const Home = () => {
  const navigation = useNavigation();
  const [pageTab, setPageTab] = useState(0);
  const [investorProfile, setInvestorProfile] = useState();
  const [level, setLevel] = useState();
  const [nameuser, setNameUser] = useState('');
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);

  useEffect(() => {
    getDataUsers();
  }, []);
  const getDataUsers = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoading1(true)
    api.get(`/clients/getDetails/client`, {
      headers: { Authorization: `Basic ${token}` },
    })
      .then(async (res) => {
        const username = res.data.name_user[0].name.toString()
        const level = res.data.user[0].client.level.toString();
        const userType = res.data.user[0].client.cnpj ? 'PJ' : 'PF'
        await AsyncStorage.setItem("usertype", userType);
        await AsyncStorage.setItem("level", level);
        await AsyncStorage.setItem("nameuser", username);
        setInvestorProfile(res.data.user[0].client.is_investor_profile);
        setLevel(res.data.user[0].client.level);
        setNameUser(username)
        setLoading1(false)
      })
      .catch((error) => {
        console.log("err", error);
        setLoading1(false)
        toast("Houve um erro, tente novamente.", "#DA1414");
      });
  };

  function openInvestorProfile() {
    navigation.navigate("InvestorProfile");
  }

  const openBannerTokenMarketplace = async () => {
    await AsyncStorage.setItem("id_token", '1');
    navigation.navigate('DetailsCoin');
  }
  return (
    <>
      <ScreenLoader loading={loading1 || loading2 || loading3} />

      <Header route={"MyAccount"} loading={value => setLoading3(value)} nameuser={nameuser} />
      <ScrollView style={styles.container}>
        <CardsHome />
        <ScrollView style={styles.content}>
          {investorProfile ? (
            <></>
          ) : (
            <>
              {level === 3 ? (
                <TouchableOpacity
                  onPress={openInvestorProfile}
                  style={styles.contentInvestorProfile}
                >
                  <Text style={styles.textInvestorProfile}>
                    Criar perfil do investidor
                  </Text>
                </TouchableOpacity>
              ) : (
                <></>
              )}
            </>
          )}

          <Text style={styles.title}>Destaques</Text>
          <TouchableOpacity
            style={{ ...styles.cardHighlight, flex: 1, alignItems: 'flex-start', flexDirection: 'row' }}
            onPress={() => { openBannerTokenMarketplace() }}
          >
            <Image
              source={require("../../../assets/bannerCarbo.png")}
              style={{
                flex: 1,
                width: '33%',
                resizeMode: 'contain',
                minHeight: 120
              }}
            />
          </TouchableOpacity>

          <Text style={styles.title}>Sugestão de Tokens</Text>
          <TokenReleases loading={value => setLoading2(value)} />
        </ScrollView>
      </ScrollView>
    </>
  );
};

export default Home;
